export default {"src":"https://cdn.tanzhi.cn/_next/static/media/person-b.28f5a399.svg","height":56,"width":57,"blurWidth":0,"blurHeight":0};